module.exports = __webpack_public_path__ + "static/img-main-3f4c98f37c4a28300d95259f115fc9e3.jpg";